import * as React from 'react';

function Breweries(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={19} viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.625 1.375C4.625.777 5.117.25 5.75.25c.598 0 1.125.527 1.125 1.125 0 .633-.527 1.125-1.125 1.125a1.11 1.11 0 01-1.125-1.125zM8 3.063c0-.915.738-1.688 1.688-1.688.914 0 1.687.773 1.687 1.688 0 .949-.773 1.687-1.688 1.687C8.739 4.75 8 4.012 8 3.062zM1.25 8.125A1.11 1.11 0 01.125 7c0-.598.492-1.125 1.125-1.125h13.5c.598 0 1.125.527 1.125 1.125 0 .633-.527 1.125-1.125 1.125h-.14c.667 1.16 1.265 2.602 1.265 3.902 0 1.301-.422 2.426-1.125 3.34v2.04a.833.833 0 01-.844.843c-.492 0-.844-.352-.844-.844v-.527c-1.44.914-3.234 1.371-5.062 1.371-1.863 0-3.656-.457-5.063-1.371v.527a.833.833 0 01-.843.844c-.492 0-.844-.352-.844-.844v-2.039c-.738-.914-1.125-2.039-1.125-3.34 0-1.3.563-2.742 1.23-3.902H1.25z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Breweries;
